import { observer } from "mobx-react-lite";
import { Form as FinalForm, Field } from "react-final-form";
import { isRequired, combineValidators } from "revalidate";
import React, { useContext, useEffect } from "react";

// reactstrap components
import { Button, FormGroup, Form, Col, Row, Card, CardBody, CardHeader } from "reactstrap";

import { useTranslation } from "react-i18next";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import { RouteComponentProps } from "react-router";
import { RootStoreContext } from "../app/stores/rootStore";
import CheckboxInput from "../components/common/CheckboxInput";
import Loader from "../components/common/Loader";
import LogoCompany from "../components/common/LogoCompany";
import TextInput from "../components/common/TextInput";
import { translationHookOptions } from "../app/localization/localization";
import classNames from "classnames";

interface IParams {
  tenant: string;
}

const MicrophoneSelectionLayout: React.FC<RouteComponentProps<IParams>> = ({
  history,
  location,
  match,
}) => {
    const rootStore = useContext(RootStoreContext);
  const { loadingCompany } = rootStore.commonStore;
  const { microphoneStationId, isInternalStation, setStation } = rootStore.broadcastStore;
  const [t] = useTranslation(["translation", "guest"], translationHookOptions);

  const handleResize = () => {
    let responsivePaddingTop = document.documentElement.clientHeight * 0.05;
    document.body.style.paddingTop = `${responsivePaddingTop}px`;
  };

  useEffect(() => {
    clearAllBodyScrollLocks();
      let responsivePaddingTop = document.documentElement.clientHeight * 0.05;
      window.addEventListener("resize", handleResize);
      //connesso alla rete
      // document.body.classList.remove("pt-0");
      document.body.classList.add("form-membership");
      // document.body.classList.add("pt-0");
      document.body.style.paddingTop = `${responsivePaddingTop}px`;

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [
    history,
    location.search,
  ]);

  const validate = (values: any) => {
    return combineValidators({
      microphoneStationId: (value: any) => {
        if (values.isInternalStation) {
          return isRequired({ message: "microphoneStationId is required" })(value);
        }
        return undefined;
      },
    })(values);
  };

  if (loadingCompany) return <Loader />;

  return (
    <div style={{display:"flex", justifyContent: "center", flexDirection: "column", alignItems: "center"}}>
      <div style={{width: "100%", display: "flex", marginBottom: "5rem"}}>
 <Button
        onClick={(e) => {
          e.preventDefault();
          history.goBack();
        }}
          style={{
            width: '10rem',
            borderRadius: '50rem',
            height: '2.5rem',
            display: 'flex',
            alignContent: 'center',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          className="btn btn-block btn-lg"
            color="dark"
             >
   <span className="btn-inner--icon">
        <i  style={{marginRight:"2px" }}className="fas fa-arrow-left" />
      </span>
      <span className="btn-inner--text">  {t("back")}</span>
  </Button>
{/* 
        <Button
        style={{backgroundColor: "black", color: "#fff", borderRadius: "50.0px"}}
          className={classNames("backNavbarButton")}
          onClick={(e) => {
            e.preventDefault();
            history.goBack();
          }}
          color="inherit"
        >
          <i className="fas fa-chevron-left"> {t("back")}</i>
        </Button> */} 
      </div>
      
    <Card style={{width: "90%"}}>
      
      <CardHeader style={{backgroundColor:"black"}}>
        <p style={{color:"white", marginBottom:"0px"}}>{t("settings_Microphone")}</p>
      </CardHeader>
      <CardBody>
          <Row className="justify-content-center" >
             <div className="form-wrapper mt-0" >
                <div style={{marginBottom: "15%"}}>
                    <LogoCompany className="loginLogo" />
                </div>
                <FinalForm
                
                    initialValues={{
                        isInternalStation: isInternalStation,
                        microphoneStationId: microphoneStationId,
                    }}
                    onSubmit={(values: any) =>{
                        console.log(values)
                        if(!values.isInternalStation)
                        values.microphoneStationId = "";
                        setStation(values.isInternalStation, values.microphoneStationId)

                    }
                    }
                    validate={validate}
                    render={({
                    handleSubmit,
                    invalid,
                    pristine,
                    }) => (
                    <Form onSubmit={handleSubmit} role="form">
                        <FormGroup className="form-group input-group-lg">
                        <Field
                            id="isInternalStation"
                            className="form-control"
                            name="isInternalStation"
                            defaultValue={isInternalStation}
                            component={CheckboxInput}
                            type="checkbox"
                            label={t("isInternalStation_label")} //Utente Interno
                            autoComplete="isInternalStation"
                        />
                        </FormGroup>
                        <FormGroup className="form-group input-group-lg">
                        <Field
                            className="form-control"
                            id="microphoneStationId"
                            name="microphoneStationId"
                            defaultValue={microphoneStationId}
                            component={TextInput}
                            placeholder={t("microphoneStationId_placeholder")} //Id postazione Bosh
                            autoComplete="microphoneStationId"
                        />
                        </FormGroup>
                        {/* {submitError && !dirtySinceLastSubmit && (
                        <Alert color="danger">{t("invalid_credentials")}</Alert> //Id già assegnato
                        )} */}
                        <div className="text-center" style={{display:"flex", justifyContent: "center"}}>
                        <Button
                          style={{
                            width: '6rem',
                            borderRadius: '50rem',
                            height: '2.5rem',
                            display: 'flex',
                            alignContent: 'center',
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                            disabled={invalid || pristine}
                            className="btn SaveButton btn-block btn-lg"
                            color="dark"
                            type="submit"
                        >
                            {t("Save")} 
                        </Button>
                        </div>
                    </Form>
                    )}
                />
            </div>
          </Row>
          {/* </CardBody>
            </Card>
          </Jumbotron> */}
      </CardBody>
    </Card>
    </div>
  );
};

export default observer(MicrophoneSelectionLayout);